import React, { useContext } from "react";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../app/store/root";

const LogisticBackdrop = () => {
    const rootStore = useContext(RootStoreContext);

    const {
        showLoading,        
    } = rootStore.logisticBackdropStore;
        
    return (
        <div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
                open={showLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}

export default observer(LogisticBackdrop);
